import React, { useState, useEffect } from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import BackdropScI from "../../../../services/BackdropScI";
import axios from "axios";
import { uri } from "../../../../help/Api";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
// Ust
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";
import Paper from "@material-ui/core/Paper";
import { getTotalAmount } from "../../../../utils/utils";
import { useBody } from "../../invCompany/style";
import { Directions } from "@material-ui/icons";

const InvTotal = (props) => {
  const { sta, inv } = props;
  const clasm = useInvMain();
  const clas = useInvAF();
  const calssBody = useBody();
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  // const [sta, setSta] = useState({ info: [], tot: {} });
  const [showSc, setShowSc] = useState(true);
  const styfC = { fontWeight: "1300" };
  const styfCA = { fontWeight: "1300", direction: "rtl", textAlign: "right" };

  const tot_all = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot));

  const tot_discount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.discount);

  const tot_vat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.amountOfVat);

  const tot_before = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot) - sta.tot?.discount);

  const tot_net = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.tot_net);
  return (
    <Grid
      item
      container
      // className={clas.BdytotSub}
      style={{ fontFamily: "Amiri-Regular" }}
    // className={calssBody.BdymtHeaderTopp}
    >

      <Grid item xs={5} className={clas.BdyborBtRTOPTotal}>

        <div style={styfCA}>  {"الإجمالي"} {"(غير شامل الضريبة القيمة المضافة)"}</div>{" "}
      </Grid>
      <Grid item xs={5} className={clas.BdyborBtRTOPTotal}>
        {txtE.amountWithVat}
      </Grid>
      <Grid item xs={2} className={clas.BdyborBtRTOPTotal} style={{ textAlign: "center" }}>
        {tot_all}
      </Grid>
      {premiApp.billTemplate === 15 ? null :
        (
          <>
            <Grid item xs={5} className={clas.BdyborBtRTOPTotal2} >
              <div style={styfCA}>   {txtA.discount}</div>{" "}
            </Grid>
            <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>
              {txtE.discount}
            </Grid>
            <Grid item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
              {tot_discount}
            </Grid>
            <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>
              <div style={styfCA}>  {"الاجمالي بعد الخصم"}</div>{" "}
            </Grid>
            <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>
              {"Amount After Discount"}
            </Grid>
            <Grid item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
              {tot_before}
            </Grid>

          </>
        )
      }



      <Grid item xs={5} className={clas.BdyborBtRTOPTotal2} direction="rtl">

        <div style={styfCA}> {" مجموع ضريبة القيمة المضافة"}
          {"("}{inv.tax}{"%"}{")"}</div>{" "}
      </Grid>
      <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>
        {"Total VAT"}
        {"("}{inv.tax}{"%"}{")"}
      </Grid>
      <Grid item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
        {tot_vat}
      </Grid>

      <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>

        <div style={styfC}>{txtA.tot_net}</div>{" "}
      </Grid>
      <Grid item xs={5} className={clas.BdyborBtRTOPTotal2}>
        {txtE.tot_net}
      </Grid>
      <Grid item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
        {tot_net}
      </Grid>
      {premiApp.billTemplate === 17 &&
        (<>
          <Grid item xs={6} className={clas.BdyborBtRTOPTotal2}>
            {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
              ? sta?.tot?.tot_net?.toFixed(2)
              : sta?.tot?.paid}
          </Grid>
          <Grid item xs={6} className={clas.BdyborBtRTOPTotal2}>
            {"اجمالي المثبفي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
              ? 0
              : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
          </Grid>
        </>
        )}


      {premiApp.billTemplate === 19 &&
        (
          <Grid
            item
            container
            xs={12}
            style={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              fontWeight: "bold",
              direction: "rtl",
              fontFamily: "Amiri-Regular",
              textAlign: "right"
            }}
          >
            {inv.notes}
          </Grid>
        )}
      {premiApp.billTemplate === 13 && (
        <>
          <Grid item xs={3} className={clas.BdyborBtRTOPTotal2}>
            {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
              ? sta?.tot?.tot_net?.toFixed(2)
              : sta?.tot?.paid}
          </Grid>
          <Grid item xs={3} className={clas.BdyborBtRTOPTotal2}>
            {"اجمالي المثبفي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
              ? 0
              : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
          </Grid>

          <Grid item xs={3} className={clas.BdyborBtRTOPTotal2}>
            {"الرصيد قبل"}     {"     :"}
            {sta.tot?.cust_balance_old?.toFixed(2)}
          </Grid>

          <Grid item xs={3} className={clas.BdyborBtRTOPTotal2}>
            {"الرصيد بعد"}     {"     :"}
            {sta.tot?.cust_balance_new?.toFixed(2)}
          </Grid>
        </>
      )}


    </Grid>
  );
};

export default InvTotal;
